import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_f7rbrkw', 'template_w5a4jzk', form.current, 'iysVlxPLgjVDBWfZ_')
      .then((result) => {
        console.log(result.text);
        alert('Message sent successfully!');
      })
      .catch((error) => {
        console.error(error.text);
        alert('Failed to send message.');
      });

    e.target.reset();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white px-4 overflow-hidden transition-colors duration-300">
      <div className="bg-white dark:bg-gray-800 shadow-2xl rounded-2xl w-full max-w-2xl flex flex-col overflow-hidden transition-colors duration-300">
        
        {/* Contact Form */}
        <div className="w-full p-6 md:p-8 flex flex-col justify-center">
          <p className="text-gray-700 dark:text-gray-300 mb-4 text-center">
          <h3 className="text-2xl font-semibold text-blue-400 mb-2">Get in touch</h3>
          I'd love to hear from you! Whether you have a question or feedback, feel free to reach out. I'm always happy to connect and chat.
          Use the form below to send a direct message to me and I will do my best to respond as quickly as possible.
          If you’d prefer, you can also connect with me on social media. 
          Looking forward to hearing from you!
          </p>
          <form ref={form} onSubmit={sendEmail} className="space-y-4">
            <div>
              <input
                type="text"
                name="user_name"
                placeholder="Your name"
                required
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-pink-400 outline-none"
              />
            </div>
            <div>
              <input
                type="email"
                name="user_email"
                placeholder="Your email"
                required
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-pink-400 outline-none"
              />
            </div>
            <div>
              <textarea
                name="message"
                placeholder="Your message"
                rows="4"
                required
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-pink-400 outline-none"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-semibold py-2 rounded-lg transition hover:bg-blue-700"
            >
              Send Message
            </button>
          </form>
        </div>        
      </div>
    </div>
  );
};

export default ContactUs;
